module.exports = __webpack_public_path__ + "img/ceramic-teal.70b5a378.png";